import { Stt } from '../customOptions.model';

export function parseStt(sttDef: any): Stt {
  const description = {
    language: 'STT Language',
  };
  const { providers, languages } = sttDef.meta.description;

  return {
    description,
    providers,
    languages,
  };
}
